module.exports = __webpack_public_path__ + "static/icon12-04855c1d7f9a7cce3344752157e8f86d.svg";